'use client';

import React, { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import Topbar from '@/components/Topbar';
import AuditHero from './components/AuditHero';
import AuditEngine from './components/AuditEngine';

function HomeContent() {
  const searchParams = useSearchParams();
  const urlParam = searchParams?.get('url') || '';

  return (
    <main className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 pb-24">
      <AuditHero />
      <AuditEngine initialUrl={urlParam} />
    </main>
  );
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      <div
        className="fixed inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
        }}
        aria-hidden="true"
      />
      <div
        className="fixed inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(255,61,87,0.12), transparent)',
        }}
        aria-hidden="true"
      />

      <Topbar />

      <Suspense fallback={
        <main className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 pb-24">
          <AuditHero />
          <AuditEngine />
        </main>
      }>
        <HomeContent />
      </Suspense>

      <footer className="relative z-10 border-t border-border py-6 mt-8">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-muted-foreground text-sm">
            FrictionScan — Heuristic conversion audit for SaaS landing pages
          </p>
          <p className="text-muted-foreground text-xs font-mono">
            v2.0 · 10 signals · PageSpeed Insights
          </p>
        </div>
      </footer>
    </div>
  );
}